import { render, staticRenderFns } from "./chat-indice-artefatos-compacta.vue?vue&type=template&id=00d24707&scoped=true&"
import script from "./chat-indice-artefatos-compacta.vue?vue&type=script&lang=js&"
export * from "./chat-indice-artefatos-compacta.vue?vue&type=script&lang=js&"
import style0 from "./chat-indice-artefatos-compacta.vue?vue&type=style&index=0&id=00d24707&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d24707",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d24707')) {
      api.createRecord('00d24707', component.options)
    } else {
      api.reload('00d24707', component.options)
    }
    module.hot.accept("./chat-indice-artefatos-compacta.vue?vue&type=template&id=00d24707&scoped=true&", function () {
      api.rerender('00d24707', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-indice-artefatos/chat-indice-artefatos-compacta.vue"
export default component.exports